import axiosInstance from "../../components/api/axiosInstance";

const data = (res) => res.data;

/** Cloud Office Payables: vendors, the bills they send, and the payments made against them. */
const payablesApi = {
  summary: () => axiosInstance.get("/fico/payables/summary").then(data),
  vendors: (params) => axiosInstance.get("/fico/vendors", { params }).then(data),
  createVendor: (body) => axiosInstance.post("/fico/vendors", body).then(data),
  updateVendor: (id, body) => axiosInstance.put(`/fico/vendors/${id}`, body).then(data),
  deleteVendor: (id) => axiosInstance.delete(`/fico/vendors/${id}`).then(data),
  bills: (params) => axiosInstance.get("/fico/bills", { params }).then(data),
  bill: (id) => axiosInstance.get(`/fico/bills/${id}`).then(data),
  createBill: (body) => axiosInstance.post("/fico/bills", body).then(data),
  updateBill: (id, body) => axiosInstance.put(`/fico/bills/${id}`, body).then(data),
  deleteBill: (id) => axiosInstance.delete(`/fico/bills/${id}`).then(data),
  cancelBill: (id, reason) => axiosInstance.post(`/fico/bills/${id}/cancel`, { reason }).then(data),
  payments: (params) => axiosInstance.get("/fico/bill-payments", { params }).then(data),
  recordPayment: (body) => axiosInstance.post("/fico/bill-payments", body).then(data),
  cancelPayment: (id) => axiosInstance.post(`/fico/bill-payments/${id}/cancel`).then(data),
};

export default payablesApi;

export function payablesError(err, fallback = "Something went wrong") {
  return err?.response?.data?.error || err?.response?.data?.message || fallback;
}

const listFrom = (res) => (Array.isArray(res?.data) ? res.data : res?.data?.data || []);

/** Payment modes, our bank accounts and currencies for the bill and payment forms. */
export async function loadPayablesOptions() {
  const [modes, accounts, currencies] = await Promise.all([
    axiosInstance.get("/payment-modes").catch(() => ({ data: [] })),
    axiosInstance.get("/fico/company-accounts").catch(() => ({ data: [] })),
    axiosInstance.get("/currencies").catch(() => ({ data: [] })),
  ]);
  return {
    modes: listFrom(modes).map((m) => ({
      id: m.Payment_Mode_Id ?? m.payment_mode_id ?? m.id,
      name: m.Payment_Mode_Name ?? m.payment_mode_name ?? m.name ?? "",
    })),
    accounts: listFrom(accounts)
      .filter((a) => (a.Status || "Active") === "Active")
      .map((a) => ({
        id: a.Company_Account_Id,
        name: [a.Account_Name, a.Bank_Name].filter(Boolean).join(" · "),
      })),
    currencies: listFrom(currencies).map((c) => ({
      id: c.Currency_Id ?? c.currency_id ?? c.id,
      code: c.Currency_Code ?? c.currency_code ?? c.code ?? "",
    })),
  };
}
